import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, AlertCircle, Loader2, ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";

export default function VerifyEmailPage() {
  const { verifyEmail } = useAuth();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;
    if (!token) {
      setStatus("error");
      setMessage("Token mancante nel link.");
      return;
    }
    verifyEmail(token)
      .then((data) => {
        setStatus("success");
        setMessage(data?.message || "Email confermata con successo.");
      })
      .catch((e) => {
        setStatus("error");
        setMessage(
          formatApiErrorDetail(e?.response?.data?.detail) ||
            e.message ||
            "Impossibile verificare l'email."
        );
      });
  }, [token, verifyEmail]);

  return (
    <div className="px-5 sm:px-8 lg:px-12 py-20 max-w-xl mx-auto" data-testid="verify-email-page">
      <PageHeader
        eyebrow="Conferma email"
        title={
          status === "loading"
            ? "Sto verificando…"
            : status === "success"
              ? "Email confermata"
              : "Verifica non riuscita"
        }
        description={
          status === "success"
            ? "Il tuo account TIME Inside è ora attivo. Puoi accedere quando vuoi."
            : status === "error"
              ? "Il link potrebbe essere scaduto o già utilizzato."
              : "Un momento, stiamo confermando il tuo indirizzo."
        }
        testId="verify-header"
      />
      <div className="glass-card p-8 text-center">
        <div
          className={[
            "w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-6 border",
            status === "success"
              ? "bg-emerald-400/10 border-emerald-400/25"
              : status === "error"
                ? "bg-red-500/10 border-red-500/25"
                : "bg-white/[0.04] border-white/10",
          ].join(" ")}
        >
          {status === "loading" && (
            <Loader2 className="w-6 h-6 text-white/50 animate-spin" />
          )}
          {status === "success" && <Check className="w-7 h-7 text-emerald-300" />}
          {status === "error" && <AlertCircle className="w-7 h-7 text-red-300" />}
        </div>
        <p
          data-testid="verify-message"
          className="text-sm text-white/70 font-light leading-relaxed mb-8"
        >
          {message}
        </p>
        {status !== "loading" && (
          <Link
            to="/auth"
            data-testid="verify-goto-login"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-emerald-400/90 text-black text-[11px] tracking-[0.24em] uppercase font-medium hover:bg-emerald-400 transition-all"
          >
            Vai al login
            <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        )}
      </div>
    </div>
  );
}
